<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.labels') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" @update:page="updatePage" height="60vh"
                :update:sortBy="updateSortBy" :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)"
                class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="showDialog = true">
                                {{ $t('global.menu.backoffice.createLabel') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.color`]="{ value }">
                    <v-avatar v-if="value" size="x-small" class="mr-2 border-md" :color="value"></v-avatar>
                    <v-avatar v-else size="x-small" class="mr-2 border-md" color="#e88be9"></v-avatar>
                </template>
                <template v-slot:[`item.translations`]="props">
                    {{ props.item.translations ? props.item.translations[selectedLanguage.toUpperCase()].value :
                        props.item.name }}
                </template>
                <template v-slot:[`item.labelCategory`]="{ value }">
                    {{ value.name }} | {{ value.frontendId }}
                </template>
                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1" @click="() => editLabel(props.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" variant="flat" size="32" class="mr-1" @click="() => removeLabel(props.item)">
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>
        <CreateLabelDialog v-model="showDialog" v-model:data="newLabel" :items="labelCategories" :save="save">
        </CreateLabelDialog>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" :confirm-deletion="deleteLabel"
            v-model:data="removedLabel" :title="'Delete Label'" :question="'Are you sure you want to Delete ?'">
        </CustomConfirmDeletionDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateLabelDialog from './modals/CreateLabelDialog.vue';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';

export default {
    components: {
        CreateLabelDialog,
        CustomConfirmDeletionDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const newLabel = ref({});
        const removedLabel = ref(null);
        const showDialog = ref(false);
        const showDeleteDialog = ref(false);
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const removeLabel = (item) => {

            removedLabel.value = item;
            showDeleteDialog.value = true;
        }

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }
        const updatePage = (newPage) => {
            proxy.page = newPage;
        }

        const editLabel = (item) => {

            newLabel.value = { ...item };
            showDialog.value = true;
        }

        const save = async () => {
            if (newLabel.value.id) {
                const copy = { ...newLabel.value }

                try {
                    const response = await proxy.$axios.put(`/backoffice/labels/${newLabel.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            } else {
                const copy = { ...newLabel.value }

                try {
                    const response = await proxy.$axios.post(`/backoffice/labels`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
            // color : "#ff0000" frontendId : 5000 iconUrl : "home" labelCategory : {id: "b87439fb-eb39-4c36-98a2-f861ec555269", name: "INDIVIDUALIST:", translations: {,…}, frontendId: 6} name : "TEST LABEL" translations : {EN: {value: "TEST LABEL"}, DE: {value: "TEST LABEL"}} POST /api/backoffice/labels 
            // color : "#FFFF00" frontendId : 20 iconUrl : "madeInFrankfurt.png" id : "98994530-5812-43db-b18a-f3d3e38dc17e" labelCategory : {id: "4dd29901-6915-485e-ac02-ff40a297d225", name: "ZERTIFIZIERTE PRODUKTE", frontendId: 11} name : "Zertifizierte Produkte" sortOrder : 0 translations : {DE: {id: "b2cf9471-f803-4fb5-9050-10b3dfb2a9af", labelId: "98994530-5812-43db-b18a-f3d3e38dc17e",…},…} PUT /backoffice/labels/98994530-5812-43db-b18a-f3d3e38dc17e  
        }

        const deleteLabel = async (item) => {
            // DELETE /backoffice/labels/1e6a2116-5525-4317-84a6-c3f0b251d733
            try {
                const response = await proxy.$axios.delete(`/backoffice/labels/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        return {
            selectedLanguage,
            newLabel,
            showDialog,
            editLabel,
            save,
            updatePage,
            showDeleteDialog,
            deleteLabel,
            removeLabel,
            removedLabel,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Color', key: 'color', align: 'start', maxWidth: "50px", sortable: false },
            { title: 'Name', key: 'translations', align: 'start', maxWidth: "200px" },
            { title: 'FrontendId', key: 'frontendId', align: 'start' },
            { title: 'labelCategory', key: 'labelCategory', align: 'start', sortable: false },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
        labelCategories: []
    }),

    computed: {
    },

    mounted() {
        this.fetchLabelCategories();
    },

    methods: {
        fetchLabelCategories() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/label/query" : "/backoffice/labelcategories", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
            })
                .then(this.labelCategoriesFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        labelCategoriesFetched(response) {
            this.labelCategories = response.data.data;
        },
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/labels/query" : "/backoffice/v2/labels", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    // sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    lang: this.selectedLanguage.toUpperCase(),
                    ...(this.search.length >= 1 ? { search: this.search, resultsPerPage: itemsPerPage, page: page - 1, sortColumn: sortBy[0]?.key } : { page: page - 1, resultsPerPage: itemsPerPage, sortColumn: sortBy[0]?.key })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>